<template>
    <div class="ps-re">
        <el-select  style="width: 100px"  class="usebutton" v-model="i_state" size="mini"  @change="refreshTree">
            <el-option v-for="item in stateList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
            </el-option>
        </el-select>
        <div class="fitW">
            <el-tree
                    ref="tree"
                    :data="treeData"
                    lazy :key="treeId"
                    :load="loadNode"
                    :props="defaultProps"
                    node-key="wyid"
                    @node-click="handleNodeClick"
                    :default-expanded-keys="['0-0']"
                    class="trees  video-tree height100"
                    accordion
                    :highlight-current='true'
                    :expand-on-click-node="false"
                    :show-checkbox="false">
                <div class="custom-tree-node" style="width: 100%"  slot-scope="{ node, data }">
                        <span @contextmenu="showMenuFun($event,node, data)">
<!--                                <i class="el-icon-folder-opened"></i>-->
                                <el-checkbox
                                        v-if="data.type==0"
                                        :value="selectedLeafIds.includes(data.i_id)"
                                        @change="(checked) => toggleLeafSelection(data, checked)"
                                        @click.stop/>
                            <template v-if="data.type==1">
                                    <i class="el-icon-folder-opened" style="padding-right: 5px"></i>
                            </template>
                            <template v-if="data.type==0">
                                <span v-if="data.isMainType==0" class="jian ziicon">兼</span>
                                <span v-if="data.isMainType==1" class="zhi ziicon">直</span>
                                <i v-if="data.isMainType==null||data.isMainType==undefined" class="el-icon-document" style="padding-right: 5px"></i>
                            </template>
                                <span>{{ node.label }}</span>
                            <div v-if="showMenuId==data.i_id" class="menu"  style="z-index: 2">
<!--          @node-contextmenu="showMenuFun"                   :style="{left:`${menuX}px`,top:`${menuY}px`}"-->
                                <template v-if="data.type==0">
                                    <div  class="info" v-if="data.i_id"  @click.stop="addcpFun(data,'edit')"><i class="el-icon-edit" style="padding-right: 8px"></i>编辑产品</div>
                                    <div  class="info" v-if="data.i_id"  @click.stop="transferFun(data,'zycp')"><i class="el-icon-sort" style="margin-right: 8px; transform: rotate(90deg)"></i>转移产品</div>
                                    <div  class="info" v-if="data.i_id&&selectedLeafIds.length>1"  @click.stop="transferFun(selectedLeafIds,'zycppl')"><i class="el-icon-document-copy" style="margin-right: 8px; "></i>批量复制产品</div>
                                    <div  class="info" v-if="data.i_id&&selectedLeafIds.length>=1&&onei_typepid"  @click.stop="deleteFun(selectedLeafIds,i_typepidList)"><i class="el-icon-delete" style="margin-right: 8px;"></i>批量删除产品</div>
                                </template>
                                <template v-if="data.type==1">
                                    <div  class="info" v-if="data.childProduct==0"@click.stop="addcpflFun(data,'add')"><i class="el-icon-folder-add" style="padding-right: 8px"></i>新增产品分类</div>
                                    <div  class="info" v-if="data.i_id" @click.stop="addcpflFun(data,'edit')"><i class="el-icon-edit" style="padding-right: 8px"></i>编辑产品分类</div>
                                    <div  class="info" v-if="data.childKind==0"@click.stop="addcpFun(data,'add')"><i class="el-icon-folder-add" style="padding-right: 8px"></i>新增产品</div>
                                    <div  class="info" v-if="data.i_id" @click.stop="transferFun(data,'zycpfl')"><i class="el-icon-sort" style="margin-right: 8px; transform: rotate(90deg)"></i>转移产品分类</div>
                                </template>
                            </div>
                        </span>
                </div>
            </el-tree>

        </div>
    </div>

</template>

<script>
    // import * as API from "./api"
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";

    export default {
        name: "ProductTree",
        // props:{
        //     data:{
        //         type: Number,
        //         required:true,
        //     },
        // },
        components: {},
        data() {
            return {
                selectedLeafIds: [],
                defaultProps: {
                    children: 'children',
                    label: 'label',
                    isLeaf: 'isLeaf',
                    value:'i_id'
                },
                i_state:1,
                treeData:[{i_id:0,i_level:1, type:1,i_pid:0,label:'全部',children:[],isLeaf:false}],
                treeId:0,
                showMenuId:null,
                stateList:[{i_id:1,vc_name:'启用'},{i_id:-1,vc_name:'未启用'},{i_id:-2,vc_name:'全部'}],
                i_typepidList:[],
                onei_typepid:false,
            }
        },
        mounted() {
            let that=this,box=document.getElementById('tabelBox');
            box.addEventListener('mouseup',function (event) {
                if(event.button===0||event.button==2){
                    // console.log('down------------------')
                    that.showMenuId=null

                }
            })
        },
        methods: {
            toggleLeafSelection(data, checked) {
                if (checked) {
                    if (!this.selectedLeafIds.includes(data.i_id)) {
                        this.selectedLeafIds.push(data.i_id);
                    }
                    this.i_typepidList.push(data.i_typepid);
                } else {
                    this.selectedLeafIds = this.selectedLeafIds.filter(
                        (item) => item !== data.i_id
                    );
                    let i= this.i_typepidList.findIndex(t=>t==data.i_typepid)
                    this.i_typepidList.splice(i,1)
                }
            },
            refreshTree(){
                this.treeId=Math.random();
                this.selectedLeafIds=[];
                this.i_typepidList=[];
            },
            showMenuFun(event,node, data){
                //console.log(this.i_typepidList,'val')
                this.onei_typepid=this.i_typepidList.findIndex(t=>t!=this.i_typepidList[0])==-1?true:false
                event.preventDefault();
                this.showMenuId=data.i_id;
            },
            addcpflFun(val,type){
                this.showMenuId=null
                let data=JSON.parse(JSON.stringify(val))
                this.$emit('addcpflFun',data,type)
            },
            addcpFun(val,type){
                // console.log(val,'val')
                this.showMenuId=null
                let data=JSON.parse(JSON.stringify(val))
                this.$emit('addcpFun',data,type)

            },
            transferFun(val,type){
                this.showMenuId=null;
                let data=JSON.parse(JSON.stringify(val))
                this.$emit('transferFun',data,type)
            },
            deleteFun(val,i_typepidList){
                if(val.length>0){
                    this.showMenuId=null;
                    let data=JSON.parse(JSON.stringify(val))
                    this.$emit('deleteFun',data,i_typepidList[0])
                }

            },
            handleNodeClick(val){
                // console.log('val',val)
                if(val.type==1)this.selectedLeafIds=[];
                this.showMenuId=null;
                let data=JSON.parse(JSON.stringify(val))
                this.$emit('showData',data)
            },
            loadNode(node, resolve) {
                this.showMenuId=null;
                let _this=this;
                if (node.level === 0) {
                    let val={i_id:0,i_level:0, i_typepid:0,type:1,i_pid:0,label:'全部',vc_name:'全部',children:[],childProduct:0,wyid:'0-0',isLeaf:false};
                    return resolve([val]);
                }
                if (node.level>=1&&node.data.isLeaf==false){
                    _this.productTree(node.data,resolve,node.level);
                }
            },
            async productTree({i_id=0,type=0},resolve,level){
                let param = {
                    // i_mid: this.mid,
                    i_pid:i_id,
                    isuse:this.i_state,
                };
                let res = await API.productTree(param);
                if (res.code == 1) {
                    let list=[];
                    if (res.data.length>0){
                        res.data.map(one=>{
                            let hash=one;
                            hash.isLeaf= one.childProduct==0&&one.childKind==0;
                            hash.i_level= level;
                            hash.label= one.vc_name;
                            hash.wyid=one.i_typepid+'-'+one.i_id

                            //     {
                            //     label:one.vc_name,
                            //     i_id:one.i_id,
                            //     type:one.type,
                            //     i_level:level+1,
                            //     // i_pid:one.i_pid,
                            //     isLeaf: one.childProduct==0,
                            // };
                            list.push(hash);
                        })
                    }
                    return resolve(list);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
           },
    }
</script>

<style lang="scss" scoped>
    *{
        font-size: 14px;
    }
    .fitW{
        width: fit-content;
    }
    .ps-re{
    position: relative;

    }
    .usebutton{
        position: absolute;
        right: 0;
        top: 0;
        z-index: 99;
    }
    /deep/ {
        .el-tree-node__label {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .el-tree-node__content{
            width: 100%;
        }
    }
        .menu{
            /*display: flex;*/
            border: 1px solid #8e8e8e;
            left: 150px;
            position: absolute;
            background-color: #fff;
            box-shadow:0 2px 8px rgba(0,0,0,0.1);
        }
    .info{
        /*border: 1px solid #8e8e8e;*/
padding: 5px 15px;
    }
    .info:hover{
        background-color: #CCCCCC;

    }
.el-tree span{
    display: inline-block;
    width: 100%;
}
    .jian{
        background-color: #409EFF ;
    }
    .zhi{
        background-color: #ff0500;
    }
    .ziicon{
        display: inline-block;
        /*padding:3px 4px;*/
        border-radius: 4px;
        border: 1px;
        color: white;
        width: 20px !important;
        height: 19px;
        line-height: 19px;
        font-size: 12px;
        margin:0 4px;
        text-align: center;
    }
</style>